<template>
  <transition name="fade">
    <div class="ui-dialog">
      <div class="ui-dialog__overlay" @click="$emit('close')"></div>
      <div class="ui-dialog__content">
        <div class="mdl-dialog__content align--center">
          <p>Are you sure you want to delete {{ document.name }}?</p>
        </div>
        <div class="mdl-dialog__actions align--center">
          <button
            type="button"
            class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect button"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="button"
            class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
            @click="$emit('delete', document.dbDocumentId)"
          >
            Confirm
        </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['document']
}
</script>
